module.exports = __webpack_public_path__ + "images/shimo/form-grid-8dfcee5a353ba260a0f143e447511799.png";